import { AppComponent } from './app.component';

// Angular
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  provideAppInitializer,
  LOCALE_ID,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AuthGuard, CONFIGURATION } from '@acpgruppe/essp-ui';
import { AuthConfigService } from '@acpgruppe/essp-ui';

import { PermissionGuard } from '@acpgruppe/essp-ui';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { TokenInterceptorService } from './token-interceptor-service';
import { BASE_PATH } from 'app/api/variables';
import { appConfig } from 'src/environments/app-config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { EsspThemeConfiguration } from '@acpgruppe/essp-ui';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { primengLocaleDe } from 'app/shared/util/primeng-locale-de';

import { AppTrackerService } from '@acpgruppe/essp-ui';

registerLocaleData(localeDe, 'de');

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    OAuthModule.forRoot(),
    ToastrModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
  ],
  providers: [
    AuthGuard,
    AuthConfigService,
    PermissionGuard,

    provideAppInitializer(() => {
      inject(AppTrackerService);
    }),

    provideAppInitializer(() => {
      const initializerFn = (
        (initialAuthService: AuthConfigService) => () =>
          initialAuthService.initAuth(environment)
      )(inject(AuthConfigService));
      return initializerFn();
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: EsspThemeConfiguration,
      translation: primengLocaleDe,
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    { provide: BASE_PATH, useValue: environment.marketplaceBillingBackendUrl },
    { provide: CONFIGURATION, useValue: appConfig },
    { provide: LOCALE_ID, useValue: 'de' },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
